// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__1dVuv","content--empty":"styles_content--empty__rzWu7","skeleton-animation":"styles_skeleton-animation__dhpbg"};